import React from 'react'
import ReactDOM from 'react-dom'
import vidCalculatorPublic from '../../components/vid-calculator-public';
import { store } from '../../store' 

$.fn.vidReiknivel = function () {
  return this.each(function () {
    var options = $(this).data();
    options.store = store;
    ReactDOM.render(React.createElement(vidCalculatorPublic, options), this);
  });
};


/**
 * Initialize Data Attribute
 */

$(document).ready(function () {
  $('[data-vidbotarlifeyrir-reiknivel]').vidReiknivel();
});